<template>
  <div class="date-unit">
    <span v-if="needText" class="date-unit-text">时间维度：</span>
    <div class="date-unit-box">
      <div
        v-for="item in list"
        :key="item.type"
        class="date-unit-box-item"
        :class="item.type === value ? 'active' : ''"
        @click="changeType(item.type)"
      >
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateUnit',
  props: {
    value: {
      type: String,
      required: true,
      default: 'day',
    },
    list: {
      type: Array,
      default() {
        return [
          { type: 'day', text: '日' },
          { type: 'week', text: '周' },
          { type: 'month', text: '月' },
        ]
      },
    },
    needText: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    changeType(type) {
      if (this.value !== type) {
        this.$emit('input', type)
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.date-unit {
  display: flex;
  align-items: center;
  .date-unit-text {
    font-size: 14px;
    color: #606266;
    margin-right: 6px;
  }
  .date-unit-box {
    display: flex;
    .date-unit-box-item {
      width: 40px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #e9e9e9;
      font-size: 12px;
      margin: 0 4px;
      cursor: pointer;
      border-radius: 3px;
    }
    .active {
      background: #e6a23c;
      color: white;
    }
  }
}
</style>